import { apiClient } from './api';
import type {
  ComprehensionGeneratePayload,
  ComprehensionGenerateResponse,
  ComprehensionStatusResponse,
} from '../types/api.types';

export const comprehensionService = {
  /**
   * POST /ai/comprehension/generate
   * Returns 200 with cached questions or 202 when a new job was started.
   * The caller distinguishes by checking `response.questions?.length > 0`.
   */
  generate: async (payload: ComprehensionGeneratePayload): Promise<ComprehensionGenerateResponse> => {
    const { data } = await apiClient.post<ComprehensionGenerateResponse>(
      '/ai/comprehension/generate',
      payload,
      { validateStatus: (s) => s === 200 || s === 202 },
    );
    return data;
  },

  /**
   * GET /ai/comprehension/status?videoId=...
   * Returns the current job status. `questions` is populated when status="complete".
   */
  getStatus: async (videoId: string): Promise<ComprehensionStatusResponse> => {
    const { data } = await apiClient.get<ComprehensionStatusResponse>(
      '/ai/comprehension/status',
      { params: { videoId } },
    );
    return data;
  },
};
